/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const IntermediariPaR = t.interface({});

// optional attributes
const IntermediariPaO = t.partial({
  codiceIntermediario: t.string,

  enabled: t.boolean,

  faultBeanEsteso: t.boolean,

  idIntermediarioPa: t.string,

  objId: t.Integer
});

export const IntermediariPa = t.intersection(
  [IntermediariPaR, IntermediariPaO],
  "IntermediariPa"
);

export type IntermediariPa = t.TypeOf<typeof IntermediariPa>;
